'use strict';

var _require = require('lodash'),
    flow = _require.flow;

var getContentWordCount = require('./get-content-word-count');
var wordCountToReadingTime = require('./word-count-to-reading-time');

var getContentReadingTime = flow(getContentWordCount, wordCountToReadingTime);

module.exports = getContentReadingTime;